import axios from 'axios';
import { rootUrl_37 } from './rootUrl.js';
import { rootUrl } from "./rootUrl";

let url = rootUrl_37 + "/tm-data";
export let tmInfo = {
    /*通过申请人查询商标信息*/
    queryTmInfoByApplicant(params) {
        return axios.post(rootUrl + '/tmInfo/queryTmInfoTextByMulCountry', params)
    },
    // 查询商标查询服务订单
    getTrademarkQueryOrder(params) {
        return axios.post(rootUrl + '/tmInfo/getTrademarkQueryOrder', params)
    },
      // 币种价格接口
      getTrademarkQueryPrice(params) {
        return axios.post(rootUrl + '/trademark/getTrademarkQueryPrice', params)
    },
    // /*多条件组合查询商标信息*/
    // queryTmInfoByMultiCon(params) {
    //   return axios.post(rootUrl + '/tmInfo/queryTmInfoByMultiCon', params)
    // },
    // /*多条件多申请号组合查询商标信息*/
    // queryTmInfoByMultiConAndRegnos(params) {
    //   return axios.post(rootUrl + '/tmInfo/queryTmInfoByMultiConAndRegnos', params)
    // },
    // /*多条件多申请号组合查询商标信息[新]*/
    // queryTmInfoByMultiConAndRegnos1(params) {
    //   return axios.post(rootUrl + '/tmInfo/queryTmInfoByMultiConAndRegnos1', params)
    // },
    // /*续展专用查询*/
    // queryTmInfoForRenew(params) {
    //   return axios.post(rootUrl + '/tmInfo/queryTmInfoForRenew', params)
    // },
    /*通过单个申请号查询商标信息*/
    queryTmInfoByRegNo(params) {
        return axios.post(rootUrl + '/tmInfo/queryTmInfoTextByMulCountry', params)
    },
    /*通过多个申请号查询商标信息*/
    queryTmInfoByRegNos(params) {
        return axios.post(rootUrl + '/tmInfo/queryTmInfoTextByMulCountry', params)
    },
    /*通过多个申请号查询商标信息[新]*/
    queryTmInfoByRegNos1(params) {
        return axios.post(rootUrl + '/tmInfo/queryTmInfoTextByMulCountry', params)
    },
    // /*业务系统查询接口*/
    // queryTmInfoToBiz(params) {
    //   return axios.post(rootUrl + '/tmInfo/queryTmInfoToBiz', params)
    // },
    /*通过id查询商标信息*/
    queryTmInfoById(params) {
        return axios.post(rootUrl + '/tmInfo/queryTrademarkArchives', params)
    },
      // 查询付费创建订单
      search_createOrder(params) {
        return axios.post(rootUrl + '/tmInfo/createOrder', params)
    },
    // 查询试用一周
    applyTrademarkQueryTrial(params) {
        return axios.post(rootUrl + '/tmInfo/applyTrademarkQueryTrial', params)
    },
    // 微信支付参数
    wxpayJSAPIV3Order(params) {
      return axios.post(rootUrl + '/payOrder/wxpayJSAPIV3Order', params)
  },
    //查询所有国家 huangsijia
queryAllCountry(params) {
  return axios.post(rootUrl + '/country/getHandCountryList', params)
},
    // /*查询汇商数据库的申请人*/
    // queryTmInfoByApplicantPlus(params) {
    //   return axios.post(rootUrl + '/tmInfo/queryTmInfoByApplicantPlus', params)
    // },
    // /*AI-图片-excel文件导出接口*/
    // aiExport(params) {
    //   const formData = new FormData();
    //   for (let i in params) {
    //     formData.append(i, params[i]);
    //   }
    //   return axios({
    //     method: 'post',
    //     url: rootUrl + '/excelExport/aiExport',
    //     data: formData,
    //     responseType: 'blob'
    //   })
    // },
    // /*AI-文字-excel文件导出接口*/
    // textExport(params) {
    //   const formData = new FormData();
    //   for (let i in params) {
    //     formData.append(i, params[i]);
    //   }
    //   return axios({
    //     method: 'post',
    //     url: rootUrl + '/excelExport/regnoIntclsExport',//对应邱峰/excelExport/textExport
    //     data: formData,
    //     responseType: 'blob'
    //   })
    // },
    // /*申请人excel文件导出接口*/
    // applicantExport(params) {
    //   const formData = new FormData();
    //   for (let i in params) {
    //     formData.append(i, params[i]);
    //   }
    //   return axios({
    //     method: 'post',
    //     url: rootUrl + '/excelExport/applicantExport',
    //     data: formData,
    //     responseType: 'blob'
    //   })
    // },
}


// WEBPACK FOOTER //
// ./src/service/tmInfo.js